import { telephonyProviders } from "@/src/constants/telephonyConstants";
import providerManager from "@/src/services/telephony/providerManager";

const state = {
  currentProvider: null,
  providerStatus: {
    [telephonyProviders.twilio]: {
      isInitialized: false,
      deviceReady: false,
    },
    [telephonyProviders.plivo]: {
      isInitialized: false,
      deviceReady: false,
    },
    [telephonyProviders.plivoInternational]: {
      isInitialized: false,
      deviceReady: false,
    },
  },
};

const mutations = {
  setProvider(state, provider) {
    state.currentProvider = provider;
  },

  setProviderInitialized(state, { provider, isInitialized }) {
    if (state.providerStatus[provider]) {
      state.providerStatus[provider].isInitialized = isInitialized;
    }
  },

  setProviderDeviceReady(state, { provider, deviceReady }) {
    if (state.providerStatus[provider]) {
      state.providerStatus[provider].deviceReady = deviceReady;
    }
  },

  addProvider(state, provider) {
    if (!state.providerStatus[provider]) {
      state.providerStatus[provider] = {
        isInitialized: false,
        deviceReady: false,
      };
    }
  },
};

const actions = {
  selectProvider({ commit }, { number }) {
    try {
      if (!number) {
        throw new Error("Phone number is required to select provider");
      }

      const provider = providerManager.getProviderForNumber(number);
      
      if (!providerManager.isProviderEnabled(provider)) {
        throw new Error(`Provider ${provider} is not enabled`);
      }

      commit("setProvider", provider);
      return provider;
    } catch (error) {
      console.error("An error occurred while selecting provider: ", error);
      throw error;
    }
  },

  selectProviderBySourceNumber({ commit }, { sourceNumber }) {
    try {
      if (!sourceNumber) {
        throw new Error("Source number is required to select provider");
      }

      const provider = providerManager.getProviderForNumber(sourceNumber);
      
      if (!providerManager.isProviderEnabled(provider)) {
        throw new Error(`Provider ${provider} is not enabled`);
      }

      commit("setProvider", provider);
      return provider;
    } catch (error) {
      console.error(
        "An error occurred while selecting provider by source number: ",
        error,
      );
      throw error;
    }
  },

  setProviderInitialized({ commit }, { provider, isInitialized }) {
    commit("setProviderInitialized", { provider, isInitialized });
  },

  setProviderDeviceReady({ commit }, { provider, deviceReady }) {
    commit("setProviderDeviceReady", { provider, deviceReady });
  },

  addNewProvider({ commit }, provider) {
    commit("addProvider", provider);
  },
};

const getters = {
  getCurrentProvider: (state) => state.currentProvider,

  getEnabledProviders: () => providerManager.getEnabledProviders(),

  isProviderInitialized: (state) => (provider) => {
    return state.providerStatus[provider]?.isInitialized || false;
  },

  isProviderDeviceReady: (state) => (provider) => {
    return state.providerStatus[provider]?.deviceReady || false;
  },

  isCurrentProviderReady: (state) => {
    const current = state.currentProvider;
    return state.providerStatus[current]?.deviceReady || false;
  },

  getAllProvidersStatus: (state) => state.providerStatus,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
